import Node from './Node.js';

class PropertyNode extends Node {
  constructor() {
    let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let nodeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'vec4';
    super(nodeType);
    this.name = name;
  }

  getHash(builder) {
    return this.name || super.getHash(builder);
  }

  generate(builder) {
    const nodeVary = builder.getVarFromNode(this, this.getNodeType(builder));
    const name = this.name;

    if (name !== null) {
      nodeVary.name = name;
    }

    return builder.getPropertyName(nodeVary);
  }

}

export default PropertyNode;